// extracted by mini-css-extract-plugin
export default {"section":"E_kKOtt9MNBYT6_66a5a","heading":"Fc8YNRkg1roWpJX7GiSl","title":"HLxDGEtgrB3Mq9FextK8"};